module.exports = __webpack_public_path__ + "static/media/DQ1有效载荷指标.1cfbc0d5.jpg";